// admin namespace strings — EN + ES. Missing ES keys fall back to EN.
const STRINGS = {
  en: {
    // Sidebar sections
    "sidebar.catalog": "Catalog",
    "sidebar.operations": "Operations",
    "sidebar.customers": "Customers",
    "sidebar.marketing": "Marketing",
    "sidebar.site": "Site",
    // Sidebar items
    "nav.dashboard": "Dashboard",
    "nav.items": "Items",
    "nav.packages": "Packages",
    "nav.orders": "Orders",
    "nav.schedule": "Schedule",
    "nav.crew": "Crew & Attendants",
    "nav.invoices": "Invoices",
    "nav.customers": "Customers",
    "nav.inquiries": "Inquiries",
    "nav.reviews": "Reviews",
    "nav.marketing_hub": "Marketing Hub",
    "nav.blog": "Blog",
    "nav.local_seo": "Local SEO Pages",
    "nav.seo_search": "SEO & Search",
    "nav.translation": "Translation",
    "nav.themes": "Themes",
    "nav.site_builder": "Site Builder",
    "nav.template_gallery": "Template Gallery",
    "nav.media": "Media",
    "nav.settings": "Settings",
    // Header
    "header.view_site": "View Live Site",
    "header.logout": "Log out",
    "header.language": "Language",
    "header.switch_to_es": "Español",
    "header.switch_to_en": "English",
    // Common buttons/labels
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.loading": "Loading…",
    "common.back": "Back",
    "common.search": "Search",
    "common.yes": "Yes",
    "common.no": "No",
    "common.actions": "Actions",
    // Translation settings
    "translation.title": "Spanish Translation",
    "translation.subtitle": "Reach Spanish-speaking customers with an automatically translated version of your site.",
    "translation.coverage": "Coverage",
    "translation.bulk_button": "Translate everything to Spanish",
    "translation.refresh": "Refresh",
    "translation.byok_title": "Your own API key (optional)",
  },
  es: {
    "sidebar.catalog": "Catálogo",
    "sidebar.operations": "Operaciones",
    "sidebar.customers": "Clientes",
    "sidebar.marketing": "Marketing",
    "sidebar.site": "Sitio",
    "nav.dashboard": "Panel de Control",
    "nav.items": "Artículos",
    "nav.packages": "Paquetes",
    "nav.orders": "Pedidos",
    "nav.schedule": "Calendario",
    "nav.crew": "Equipo y asistentes",
    "nav.invoices": "Facturas",
    "nav.customers": "Clientes",
    "nav.inquiries": "Consultas",
    "nav.reviews": "Reseñas",
    "nav.marketing_hub": "Centro de Marketing",
    "nav.blog": "Blog",
    "nav.local_seo": "Páginas SEO Locales",
    "nav.seo_search": "SEO y Búsqueda",
    "nav.translation": "Traducción",
    "nav.themes": "Temas",
    "nav.site_builder": "Constructor de sitio",
    "nav.template_gallery": "Galería de plantillas",
    "nav.media": "Medios",
    "nav.settings": "Ajustes",
    "header.view_site": "Ver Sitio en Vivo",
    "header.logout": "Cerrar sesión",
    "header.language": "Idioma",
    "header.switch_to_es": "Español",
    "header.switch_to_en": "Inglés",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.add": "Añadir",
    "common.loading": "Cargando…",
    "common.back": "Volver",
    "common.search": "Buscar",
    "common.yes": "Sí",
    "common.no": "No",
    "common.actions": "Acciones",
    "translation.title": "Traducción al Español",
    "translation.subtitle": "Llega a clientes hispanohablantes con una versión de tu sitio traducida automáticamente.",
    "translation.coverage": "Cobertura",
    "translation.bulk_button": "Traducir todo al Español",
    "translation.refresh": "Actualizar",
    "translation.byok_title": "Tu propia clave API (opcional)",
  },
};

export default STRINGS;
